import React from 'react';
import PropTypes from 'prop-types';

import IconBackward from './svg/IconBackward';

function ButtonBackwardPreview({ id, size = 20, className, style, onClick }) {
  const overrideClick = (e) => {
    if (onClick) { onClick(e); }
  }
  return (
    <div id={id} onClick={overrideClick} className={`button-backward-preview ${className}`} style={{...style, cursor: 'pointer'}}>
      <IconBackward size={size} />
    </div>
  )
}

ButtonBackwardPreview.propTypes = {
  id: PropTypes.any.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default ButtonBackwardPreview;
